import {useCallback, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import classes from './Steps.module.scss';
import {PeriodToggle} from '../ClickingOverview/components/PeriodToggle/PeriodToggle';
import {Legend} from '../ClickingOverview/components/Legend/Legend';
import {format} from 'date-fns';
import {GET_PATIENT_STEPS_REQUEST} from '../../../../../redux/actions';
import {StepsGraph} from './components';

const legendData: any[] = [
  [
    {
      label: 'Steps',
      color: '#7897FF',
    },
  ],
  [
    {
      label: 'Distance',
      color: '#032596',
    },
  ]
];

export const Steps = ({
  patientId,
}: {
  patientId: string;
}) => {
  const dispatch = useDispatch();
  const [dates, setDates] = useState<null | {start: Date, end: Date}>(null);

  const getPatientSteps = useCallback(() => {
    dispatch({
      type: GET_PATIENT_STEPS_REQUEST,
      payload: {
        patientId,
        startDate: format(dates?.start ?? new Date(), 'yyyy-MM-dd'),
        endDate: format(dates?.end ?? new Date(), 'yyyy-MM-dd'),
      }
    })
  }, [dispatch, patientId, dates]);

  useEffect(() => {
    getPatientSteps();
  }, [getPatientSteps])

  return (
    <div className={classes.clickingOverviewContainer}>
      <div className={classes.chartHeader}>
        <PeriodToggle setDates={setDates} />

        <Legend legendData={legendData} />
      </div>
      <StepsGraph />
    </div>
  );
};
